export default "__VITE_ASSET__30be557a__"